import { Context } from '@nuxt/types';
import SessionModule from '~/store/session';
export default async function(context: Context) {}
